import { useEffect, useState } from 'react';

const WHATSAPP_NUMBER = '221771234567'; // +221 77 123 45 67 — remplacer par le vrai numéro Balmart
const HIDDEN_PATHS = ['/cart', '/payment-success', '/payment-cancelled', '/dashboard', '/admin', '/admin-login'];

export default function WhatsAppButton() {
  const [visible, setVisible] = useState(false);
  const [pulse, setPulse] = useState(false);

  useEffect(() => {
    // Hide on specific pages
    const check = () => {
      const path = window.location.pathname;
      setVisible(!HIDDEN_PATHS.some(p => path.startsWith(p)));
    };
    check();
    const t = setTimeout(() => setPulse(true), 3500);
    window.addEventListener('popstate', check);
    return () => { window.removeEventListener('popstate', check); clearTimeout(t); };
  }, []);

  if (!visible) return null;

  const message = encodeURIComponent(
    "Bonjour Balmart ! Je viens de visiter votre site et j'aimerais poser quelques questions sur vos produits \uD83D\uDC47"
  );
  const href = `https://wa.me/${WHATSAPP_NUMBER}?text=${message}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-floating-btn"
      aria-label="Discuter avec Balmart sur WhatsApp"
      className="fixed z-[60] bottom-5 right-5 sm:bottom-6 sm:right-6 flex items-center justify-center w-14 h-14 rounded-full shadow-2xl transition-transform hover:scale-110"
      style={{
        backgroundColor: '#25D366',
        boxShadow: pulse ? '0 0 0 0 rgba(37, 211, 102, 0.7)' : '0 10px 30px rgba(0,0,0,0.2)',
        animation: pulse ? 'wa-pulse 2s infinite' : 'none',
      }}
    >
      <svg viewBox="0 0 32 32" fill="#fff" width="28" height="28" aria-hidden="true">
        <path d="M16.003 3C9.377 3 4 8.376 4 15.002c0 2.39.696 4.613 1.89 6.49L4 29l7.703-1.857a11.94 11.94 0 0 0 4.3.794h.001C22.628 27.937 28 22.562 28 15.937 28 12.69 26.77 9.64 24.52 7.393 22.272 5.143 19.223 3.914 15.976 3.914l.027-.914zm0 2c5.524 0 10.01 4.485 10.01 10.004 0 5.523-4.485 10.004-10.013 10.004a9.91 9.91 0 0 1-5.046-1.373l-.36-.213-4.569 1.102 1.123-4.45-.235-.375A9.94 9.94 0 0 1 6 15.005C6 9.485 10.48 5 16.003 5zm-4.63 5.247c-.22 0-.578.083-.881.414-.303.33-1.157 1.13-1.157 2.757 0 1.625 1.185 3.2 1.35 3.42.167.22 2.302 3.516 5.67 4.928 2.795 1.17 3.362 1.005 3.97.95.607-.056 1.956-.8 2.23-1.57.275-.77.275-1.43.192-1.57-.082-.137-.303-.22-.633-.385-.33-.165-1.956-.965-2.26-1.074-.302-.11-.523-.165-.744.165-.22.33-.854 1.075-1.047 1.296-.192.22-.385.247-.715.083-.33-.165-1.395-.515-2.658-1.64-.983-.874-1.647-1.955-1.84-2.285-.192-.33-.02-.508.144-.673.148-.147.33-.385.495-.577.165-.193.22-.33.33-.55.11-.22.055-.413-.028-.578-.083-.165-.742-1.79-1.017-2.452-.27-.65-.544-.56-.744-.57-.192-.01-.413-.012-.633-.012z"/>
      </svg>
    </a>
  );
}
